import React, { useState, useEffect, useRef } from 'react';
import { rqx } from '../../../../../../../../../../core/request/API';
import { env } from '../../../../../../../../../../core/Env';
import { LocationOn } from '@mui/icons-material';

const getLatLng = async (address) => {
  const data = await rqx.post(`<<tool>>/${env()}/template/google_geocode_address?address=${address}`);
  if (!data.results.length) throw new Error("Invalid address: " + address);
  return data.results[0].geometry.location; // { lat, lng }
};

const GoogleMapsAutocomplete = ({ setMarker, onLocationSelect }) => {
  const [input, setInput] = useState('');
  const [predictions, setPredictions] = useState([]);
  const autocompleteService = useRef(null);

  useEffect(() => {
    if (!window.google) return;

    if (!autocompleteService.current) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }

    if (input.length > 2) {
      autocompleteService.current.getPlacePredictions(
        { input },
        (preds, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setPredictions(preds);
          } else {
            setPredictions([]);
          }
        }
      );
    } else {
      setPredictions([]);
    }
  }, [input]);

  const handleSelect = async (place) => {
    setInput(place.description);
    setPredictions([]);
    const location = await getLatLng(place.description);
    setMarker(location);
    onLocationSelect({ ...location, details: place.description, place_id: place.place_id });
  };

  // Styles
  const styles = {
    container: {
      position: 'relative',
      width:'100%',
      fontFamily: 'Arial, sans-serif',
      background:'#fff',
      padding:'0 20px',
      borderRadius:'50px',
      boxShadow:'0px 1px 10px rgba(0, 0, 0, 0.2)',
    },
    input:{
      height:"45px",
      border:"none",
      outline:"none",
      width:"100%",
      fontSize:"15px"
    },
    inputFocus: {
      borderColor: '#0056b3',
    },
    dropdown: {
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      maxHeight: '200px',
      overflowY: 'auto',
      backgroundColor: '#fff',
      border: '1px solid #ddd',
      borderRadius: '4px',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      zIndex: 10,
    },
    dropdownItem: {
      padding: '10px',
      fontSize: '15px',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
    },
    dropdownItemHover: {
      backgroundColor: '#f0f0f0',
    },
    dropdownItemActive: {
      backgroundColor: '#e0e0e0',
    },
    selectedItem: {
      backgroundColor: '#0056b3',
      color: 'white',
    },
  };

  return (
    <div style={styles.container}>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Enter your location"
        style={styles.input}
        inputprops={{
          style: styles.input,
          onFocus: (e) => e.target.style.borderColor = styles.inputFocus.borderColor,
        }}
      />
     {predictions.length > 0 && (
  <ul style={styles.dropdown}>
    {predictions.map((place, index) => (
      <li
        key={place.place_id}
        onClick={() => handleSelect(place)}
        style={{
          ...styles.dropdownItem,
          ...(index === 0 ? styles.selectedItem : {}),
          ':hover': styles.dropdownItemHover,
          ':active': styles.dropdownItemActive,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LocationOn style={{ marginRight: '8px' }} />
          <p style={{ margin: 0 }}>{place.description}</p>
        </div>
      </li>
    ))}
  </ul>
)}

    </div>
  );
};

export default GoogleMapsAutocomplete;
